import {Layout} from "@components";
import React, {useEffect, useMemo, useState} from "react";
import styles from "./style.module.scss";
import {useNav} from "@hook";
import {useRecoilValue} from "recoil";
import {states} from "@recoils";
import moment from "moment";
import * as Datas from "@data";
import {api} from "@utils";

export default function HomePage() {
  const {getParams} = useNav();
  const {data, no} = getParams<{data?: Datas.INoticeResponse; no: number}>();
  const advData = useRecoilValue(states.advDataState);
  const [detail, setDetail] = useState<Datas.INoticeResponse | undefined>(data);

  const jAdv = useMemo(() => {
    const jAdv = advData.find(
      item => (item.type || "").toLocaleUpperCase() === "J",
    );
    return jAdv;
  }, [advData]);

  async function getDetail() {
    if (detail?.no) {
      return;
    }

    try {
      const {success, data} = await api.v1.notice.getDetail({no});
      if (success) {
        setDetail(data);
      }
    } catch (error) {
      console.error("getDetail error", error);
    }
  }

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <Layout>
      <div className={styles.container}>
        {!!jAdv && (
          <div className={styles.advContainer}>
            <img src={jAdv.files?.[0]?.url} alt={jAdv.title || "광고"} />
          </div>
        )}

        <div className={styles.content}>
          <div className={styles.titleContainer}>
            <div className={styles.title}>{detail?.title}</div>
            <div className={styles.subTitle}>
              <span>{moment(detail?.created_at).format("YYYY.MM.DD")}</span>
            </div>
          </div>
          <div className={styles.imageContainer}>
            {(detail?.files || []).map(({url}, index) => {
              return (
                <img key={index} src={url} alt={url} className={styles.img} />
              );
            })}
          </div>
          {!!detail?.content && (
            <div className={styles.contentContainer}>{detail?.content}</div>
          )}
        </div>
      </div>
    </Layout>
  );
}
